import { render, staticRenderFns } from "./DetectionIndex.vue?vue&type=template&id=6347864e&scoped=true&"
import script from "./DetectionIndex.vue?vue&type=script&lang=js&"
export * from "./DetectionIndex.vue?vue&type=script&lang=js&"
import style0 from "./DetectionIndex.vue?vue&type=style&index=0&id=6347864e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347864e",
  null
  
)

export default component.exports